import { combineReducers } from 'redux';
import { curryRight } from 'lodash/fp';
import attendances from './attendances';
import setDefaultValue from '../../utils/setDefaultValue';

const identityReducerWithShapeOf = curryRight(setDefaultValue);

export default combineReducers({
  attendances,
  event: identityReducerWithShapeOf({}),
  meta: identityReducerWithShapeOf({}),
  session: identityReducerWithShapeOf({}),
});
